import { render, staticRenderFns } from "./NuevoTurno.vue?vue&type=template&id=5f74ef8e"
import script from "./NuevoTurno.vue?vue&type=script&lang=js"
export * from "./NuevoTurno.vue?vue&type=script&lang=js"
import style0 from "./NuevoTurno.vue?vue&type=style&index=0&id=5f74ef8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports